import { gql } from '@apollo/client';
import { useMutation } from '@apollo/client';

import {
  PostToWorkOrderMessageThread,
  PostToWorkOrderMessageThreadVariables,
} from '../../athena/types/PostToWorkOrderMessageThread';

export const POST_TO_WORK_ORDER_MESSAGE_THREAD = gql`
  mutation PostToWorkOrderMessageThread(
    $authorId: String!
    $content: String!
    $newStatus: OdProtosRefurbyData_MessageThreadStatus!
    $workOrderId: String!
  ) {
    refurby {
      postToWorkOrderMessageThread(
        input: {
          authorId: $authorId
          content: $content
          newStatus: $newStatus
          workOrderId: $workOrderId
        }
      ) {
        messageThread {
          notes {
            id
          }
        }
      }
    }
  }
`;

export const usePostToWorkOrderMessageThread = () => {
  return useMutation<PostToWorkOrderMessageThread, PostToWorkOrderMessageThreadVariables>(
    POST_TO_WORK_ORDER_MESSAGE_THREAD,
  );
};
